import request from './request'

// 任务列表
export function aiGetList(params) {
  return request({
    url: '/ai/list',
    method: 'get',
    params
  })
}

// 任务详情
export function aiGetDetail(id) {
  return request({
    url: '/ai/detail/' + id,
    method: 'get'
  })
}

// 导出数据
export function aiExportExcel(data) {
  return request({
    url: '/ai/export',
    method: 'post',
    data
  })
}

// 导出数据--印花提取页
export function printExportExcel(data) {
  return request({
    url: '/ai/export_v2',
    method: 'post',
    data
  })
}

// AI 图片生成任务
export function aiCreate(data) {
  return request({
    url: '/ai/create',
    method: 'post',
    data
  })
}

// 任务完成数量
export function aiGetTaskNum(task_ids) {
  return request({
    url: '/ai/batch_progress',
    method: 'get',
    params: { task_ids }
  })
}

// 统计数量
export function aiGetStatistics() {
  return request({
    url: '/ai/statistics',
    method: 'get'
  })
}

// 标题提取 侵权检测 获取模型
export function aiGetModellist() {
  return request({
    url: '/ai/model-list',
    method: 'get'
  })
}

// 标题提取 编辑图片标题
export function aiEditImageTitle(data) {
  return request({
    url: '/ai/update-content',
    method: 'post',
    data
  })
}

// 按模板导出数据
export function aiExport(data) {
  return request({
    url: '/ai/generateExcel',
    method: 'post',
    data
  })
}

// 侵权检测 获取侵权范围
export function aiGetInfringScope() {
  return request({
    url: '/ai/infringement-detection',
    method: 'get'
  })
}

// 侵权检测 编辑侵权范围
export function aiEditInfringScope(data) {
  return request({
    url: '/ai/infringement-detection',
    method: 'post',
    data
  })
}

// 备注
export function aiRemark(data) {
  return request({
    url: '/ai/update-remarks',
    method: 'post',
    data
  })
}

// 取消任务
export function aiDelete(id) {
  return request({
    url: '/ai/delete-prompt/' + id,
    method: 'delete'
  })
}

// 积分配置
export function aiGetBeansConfig(type) {
  return request({
    url: '/ai/rules',
    method: 'get',
    params: { type }
  })
}

